<template>
    <div>
        <transition name="no-mode-fade">
            <div id="noConfiguredOrders">
                <Card :bordered="false" :padding="10">
                <div slot="title">下游在租合约列表</div>
                <Form ref="formValidate" :label-width="115" inline>
                    <FormItem label="下游客户">
                        <plt-biz-select v-model="queryParams.leaseeId" :transfer="false" :params="{params:{}}" style="width: 200px" 
                        url="http://CORE-CONTRACT/messageService/queryService/queryCustomerOfCarlsberg"/>
                    </FormItem>
                    <Button @click="$refs['dg'].loadFirstPage()" type="primary" style="width: 100px; margin-left: 20px">查询</Button>
                </Form>
                <plt-table ref="dg" url="http://CORE-CONTRACT/messageService/queryService/queryRentInfoOfCarlsbergCustomer" :queryParams="queryParams" paramName="params" style="margin-top: 10px">
                    <el-table-column prop="id" label="合约号" width="180"/>
                    <plt-table-dict-col prop="leaseeId" label="下游客户" width="250" namespace="bizObjects" id="member" />
                    <el-table-column prop="deliveredDate" label="起租时间" width="150"/>
                    <el-table-column prop="amount" label="起租数量" width="120"/>
                    <el-table-column prop="rentDays" label="已租天数" width="120"/>
                    <el-table-column prop="rentingAmount" label="在租数量" width="120"/>
                </plt-table>
                </Card>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    components: {
        
    },
    data(){
        return{
            queryParams : {},
        }
    },
    mounted(){

    },
    methods:{
        
    }
}
</script>